import { PackageTheme } from '~app/styles/pricing/types';
import { Packages } from '~shared/constants/pricing';
import { pricingPalette } from '~app/styles/pricing/colors';

const grow2792Theme: PackageTheme = {
  [Packages.Enterprise]: {
    primary: pricingPalette.colors.charcoal,
  },
  [Packages.TeamAdvantage]: {
    primary: pricingPalette.colors.sabaeus,
  },
  [Packages.TeamPremier]: {
    primary: pricingPalette.colors.midnight,
  },
};

export default grow2792Theme;
